

// Required data attributes:
// data-module=closed-for-session (on the main HTML element) // Create an instance of the module
// data-closed-for-session-id : string // ID of the instance. Must be on the same element as the data-module and on every closing CTA

// Optionnal data attributes
// data-items-dynamic : string // CSS selector to target dynamically created elements. Act as a closing CTA.

var closedForSession = function() {
	var modules = document.querySelectorAll('[data-module~=closed-for-session]:not([data-closed-for-session-active="true"])');
	
	for(var i=0; i < modules.length; i++) {
		const moduleInstance = modules[i];
		const dataSessionStorageId = moduleInstance.dataset.closedForSessionId;
		const items = document.querySelectorAll(`[data-closed-for-session-id="${dataSessionStorageId}"]:not([data-module~=closed-for-session])`);
		
		if ( sessionStorage.getItem( dataSessionStorageId ) === null && moduleInstance.dataset.sessionStorageActive !== true  ) {

			for(var i=0; i < items.length; i++) {
				const item = items[i];
				item.addEventListener("click", setSessionStorageId, false);
				item.dataset.sessionStorageActive = 'true';
			}

			if( moduleInstance.dataset.itemsDynamic != null ) {
				document.addEventListener("click", isItemDynamic, false);
			}
		}

		function isItemDynamic(event){
			const itemDynamic = event.target;
			if( itemDynamic.matches( moduleInstance.dataset.itemsDynamic ) ) {
				itemDynamic.dataset.dataSessionStorageId = dataSessionStorageId;
				setSessionStorageId();
			}
		}

		function setSessionStorageId() {
			this.removeEventListener( 'click', setSessionStorageId );
			document.removeEventListener( 'click', isItemDynamic );

			sessionStorage.setItem( dataSessionStorageId, 'true' );
			const itemsSession = document.querySelectorAll( `[data-closed-for-session-id="${dataSessionStorageId}"]` );
			for(var i=0; i < itemsSession.length; i++) {
				itemsSession[i].removeEventListener( 'click', setSessionStorageId );
			}
		}
	}
};

